<template>
  <div>
    <div id="ratings" style="height: 1px"></div>
    <div class="tabs tabs-overflow">
      <ul id="refapp-tabs-titles" :style="{ left: nextPosition + '%' }" class="tabs-titles">
        <li v-for="(tab, i) in tabs" :key="`tab-${i}`" :class="{ active: activeTab === tab }">
          <a
            :id="tagging[i].eventAction.split('::')[1]"
            href="#"
            :data-review="tab"
            class="border-transition-left"
            @click.prevent="activate(tab, tagging[i])"
          >
            <h2>{{ tab }}</h2>
          </a>
        </li>
      </ul>
      <slot></slot>
    </div>
  </div>
</template>

<script>
const LEFT = 'left';
const RIGHT = 'right';
const langs = document.querySelector('html').attributes.lang;

export default {
  name: 'tabs',
  data() {
    return {
      activeTab: '',
      titleIndex: 0,
      nextPosition: 0,
      tabs: [],
      mousedown: false,
      dragOffset: 0,
      dragStartX: 0,
      minSwipeDistance: 40,
      tagging: [],
      writeReviews: true,
      readReviews: false,
    };
  },
  mounted() {
    if ('ontouchstart' in window) {
      this.$el.addEventListener('touchstart', this.handleTouchDown);
      this.$el.addEventListener('touchend', this.handleTouchEnd);
    }
    const self = this;
    window.onscroll = function () {
      const element = document.querySelector('.rr-all-review-item');
      self.isInViewport(element);
    };
  },
  created() {
    window.eventBus.$on('kerastaseRatingsTabEnable', () => {
      const review = document.getElementById('reviews').dataset.review;
      this.swipeHandlerOnTouch(review);
    });
    window.eventBus.$on('ScrollFalse', () => {
      this.writeReviews = false;
    });
    window.eventBus.$on('ScrollTrue', () => {
      this.writeReviews = true;
    });
  },

  methods: {
    isInViewport(element) {
      if (element) {
        const rect = element.getBoundingClientRect();
        if (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        ) {
          this.tiggerReviewAction();
        }
      }
    },
    activate(tab, tagging) {
      if (this.tabs.indexOf(tab) > this.titleIndex) {
        this.swipeHandler(LEFT);
      } else if (this.tabs.indexOf(tab) < this.titleIndex) {
        this.swipeHandler(RIGHT);
      }
      this.activeTab = tab;
      if (tagging.eventAction.split('::')[1] === 'reviews') {
        this.readReviews = true;
        this.swipeHandlerOnTouch('Reviews');
      } else {
        this.readReviews = false;
      }
      this.$emit('activateTab', tab);
      const name = document.getElementById('poductdetail').value;
      const id = document.getElementById('productID').value
        ? `::${document.getElementById('productID').value}`
        : '';
        dataLayer.push({ //eslint-disable-line
        event: 'uaevent',
        ecommerce: 'undefined',
        eventCategory: 'product detail page',
        eventLabel: `${name.toLowerCase()}${id}`,
        eventAction: this.activeTab.toLowerCase(),
        event_name: 'product_info_click',
        product_tab: this.activeTab.toLowerCase(),
        product_info: `${name.toLowerCase()}${id}`,
      });
    },
    swipeHandler(direction) {
      if (this.writeReviews) {
        const SCROLL_STEP = 50;
        const maxPosition = -(this.tabs.length - 1) * SCROLL_STEP;
        const maxRTLPosition = (this.tabs.length - 1) * SCROLL_STEP;
        if (langs !== undefined && langs.value === 'he') {
          if (direction === LEFT && this.nextPosition < maxRTLPosition) {
            this.nextPosition += SCROLL_STEP;
            this.titleIndex++;
            this.activeTab = this.tabs[this.titleIndex];
            this.$emit('activateTab', this.tabs[this.titleIndex]);
          } else if (this.nextPosition > 0) {
            this.nextPosition -= SCROLL_STEP;
            this.titleIndex--;
            this.activeTab = this.tabs[this.titleIndex];
            this.$emit('activateTab', this.tabs[this.titleIndex]);
          }
        } else if (direction === LEFT && this.nextPosition > maxPosition) {
          this.nextPosition -= SCROLL_STEP;
          this.titleIndex++;
          this.activeTab = this.tabs[this.titleIndex];
          this.$emit('activateTab', this.tabs[this.titleIndex]);
        } else if (this.nextPosition < 0) {
          this.nextPosition += SCROLL_STEP;
          this.titleIndex--;
          this.activeTab = this.tabs[this.titleIndex];
          this.$emit('activateTab', this.tabs[this.titleIndex]);
        }
      }
    },
    swipeHandlerOnTouch(tabs) {
      this.titleIndex = 4;
      this.nextPosition = -100;
      this.activeTab = tabs;
      this.$emit('activateTab', tabs);
    },
    handleTouchDown(e) {
      this.mousedown = true;
      this.dragStart = e.touches[0].clientX;
    },
    handleTouchEnd() {
      this.mousedown = false;
      this.dragOffset = 0;
    },
    handleTouchUp() {
      this.mousedown = false;
      this.dragOffset = 0;
    },
    handleTouchMove(e) {
      if (!this.mousedown) {
        return;
      }

      let eventPos = 0;
      let delta = 0;

      eventPos = e.touches[0].clientX;
      delta = this.dragStart - eventPos;
      this.dragOffset = delta;

      if (this.dragOffset > this.minSwipeDistance) {
        this.handleTouchUp(RIGHT);
        this.swipeHandler(LEFT);
      } else if (this.dragOffset < -this.minSwipeDistance) {
        this.handleTouchUp();
        this.swipeHandler(RIGHT);
      }
    },
    tiggerReviewAction() {
      let result = false;
      const div = document.querySelector('.rr-all-review-item');
      if (div != null) {
        result = div.classList.contains('rr-all-review-item');
      }
      const productName = document.getElementById('poductdetail').value;
      let productID = document.getElementById('productID').value;
      if (productID === '') {
        productID = 'none';
      }
      try {
        if (this.readReviews && result) {
          this.readReviews = false;
          dataLayer.push({
            event: 'uaevent',
            event_name: 'read_review',
            eventCategory: 'product detail page',
            eventAction: 'read review',
            eventLabel: productName.toLowerCase().trim() + '::' + productID,
            ecommerce: 'undefined',
            product_info: productName.toLowerCase().trim() + '::' + productID,
          });
        }
      } catch {
        console.warn('datalayer is not defined');
      }
    },
  },
};
</script>
